<template>
  <div class="answers_date" v-on-click-away="hide_picker">
    <masked-input
      v-model="date"
      :mask="[/[0-3]/, /[0-9]/, '-', /[0-1]/, /[0-9]/, '-', /[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/]"
      type="text"
      :class="['date', { error: !valid }]"
      keep-char-positions
      :placeholder="$tr('vacancy.preferences.application.dateHolder')"
      @input="set_date"
      @focus="open_picker"
      @click="open_picker"
    />

    <template v-if="!disableCurrentDates">
      <calendar
        v-if="show_picker"
        class="date-range"
        :show-lunar="false"
        :first-day-of-week="1"
        :lang="current_locale"
        @change="change"
      />
    </template>

    <template v-else>
      <calendar
        v-if="show_picker"
        :days-disabled-start="maxDateEnd"
        :days-disabled-end="minDateStart"
        class="date-range"
        :show-lunar="false"
        :first-day-of-week="1"
        :lang="current_locale"
        @change="change"
      />
    </template>
  </div>
</template>

<script>
import MaskedInput from 'vue-text-mask';
import { Calendar } from 'vue-date-range';
import { directive as VueClickAway } from 'vue-clickaway';
import isMobile from 'ismobilejs';

export default {
  name: 'AnswersDate',

  components: {
    Calendar,
    MaskedInput
  },

  directives: {
    onClickAway: VueClickAway
  },

  props: [
    'data',
    'current_locale',
    'id',
    'hide_mobile_calend',
    'hideByClick',
    'disableCurrentDates',
    'maxDate',
    'minDate',
    'isHidePickerByStart'
  ],

  data() {
    return {
      show_picker: false,
      dateChanged: null,
      isMobile: isMobile.any
    };
  },

  computed: {
    minDateStart() {
      if (!this.minDate) {
        return null;
      }
      const date = this.$moment(this.minDate, 'DD-MM-YYYY').format('YYYY-MM-DD');

      return this.$moment(date, 'YYYY-MM-DD');
    },

    maxDateEnd() {
      if (!this.maxDate) {
        return null;
      }
      const date = this.$moment(this.maxDate, 'DD-MM-YYYY').format('YYYY-MM-DD');

      return this.$moment(date, 'YYYY-MM-DD');
    },

    date: {
      get() {
        if (this.dateChanged === null) {
          return this.data || '';
        }
        return this.dateChanged;
      },

      set(val) {
        this.dateChanged = val;
        this.$emit('input', {
          date: val
        });
      }
    },

    validMomentDate() {
      const regex = /[0-3][0-9]-[0-1][0-9]-[1-2][0-9][0-9][0-9]/g;
      const date = this.$moment(this.date, 'DD-MM-YYYY');
      return date.isValid() && regex.test(this.date);
    },

    valid() {
      if (this.date && this.date.indexOf('_') !== -1) {
        return false;
      }
      if (this.date[0] === '3') {
        return this.date[1] <= 1 || this.date[1] === '_';
      } else if (this.date[3] === '1') {
        return this.date[4] <= 2 || this.date[4] === '_';
      } else {
        return true;
      }
    }
  },

  watch: {
    valid(v) {
      this.$emit('set_valid_date', v);
    },

    validMomentDate(v) {
      this.$emit('set_valid_moment_date', v);
    },

    hide_mobile_calend(v) {
      if (v) {
        this.show_picker = false;
      }
    }
  },

  methods: {
    change(v) {
      this.date = this.$moment(v).format('DD-MM-YYYY');

      this.$emit('update', {
        question_id: this.id,
        date: this.date
      });

      if (this.hideByClick) {
        this.hide_picker();
      }
    },

    set_date(v) {
      if (v && !this.isHidePickerByStart) {
        this.show_picker = true;
        this.$emit('set_mobile_calend', false);
      }
      this.date = v;
      this.$emit('update', {
        question_id: this.id,
        date: this.date
      });
    },

    async open_picker() {
      if (this.show_picker) return;

      await this.$nextTick();
      this.show_picker = true;
      this.$emit('set_mobile_calend', false);
    },

    hide_picker() {
      if (this.show_picker) {
        this.show_picker = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.answers_date {
  position: relative;
  margin-left: 17px;
  width: 230px;
  padding-top: 10px;

  .date {
    width: 150px;
    max-height: 40px;
    min-height: 40px;
    border: 1px solid #d2d6e0;

    &.error {
      border: 1px solid #f65046;
    }
  }

  .date-range {
    position: absolute;
    top: calc(100% + 5px);
    left: 0;
    border-radius: 2px;
    border: 1px solid #d2d6e0;
    background: #ffffff;
    z-index: 9;
  }
}
</style>